import { connect } from 'react-redux';
import { getLoaders } from 'selectors';
import { updateGroupCohorts } from 'actions/partner';
import { getColumnsAges } from 'selectors';
import GroupCohortsTable from 'components/reports/general/GroupCohortsTable';

const mapStateToProps = (state) => {
  return {
    ages: getColumnsAges(state.filters.ages),
    auth: state.auth,
    isLoading: getLoaders(state, ['REPORT_GROUP_COHORT_FILTER', 'REPORT_GROUP_COHORT']),
    data: state.reports.groupCohorts,
    meta: state.meta.groupCohorts,
    accountPlayers: state.accountPlayers,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onPageChange: (page) => {
      dispatch(updateGroupCohorts({page}))
    },
  }
}

const GroupCohortsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupCohortsTable)

export default GroupCohortsContainer;
